import { sectorValidator } from "../../../../quotes/quote-create-stepper/next-prev/validators/sectorWorkflowValidator";
import { QuoteModeEnum } from "../../../../quotes/quote-create-stepper/enums/quote-create.enums";

export const validateScopeOfWorkByMode = (state: any): true | string => {
  const mode = state?.quoteMode;

  if (!mode) return "Debes seleccionar Basic o Advanced.";

  const isAdvanced = mode === QuoteModeEnum.ADVANCED || mode === "advanced";

  if (isAdvanced) {
    console.log("isAdvanced")
    return validateScopeOfWorkAdvanced(state);
  }

  console.log("isBasic")
  return validateScopeOfWorkBasic(state);
};

export const validateScopeOfWorkAdvanced = (state: any): true | string => {
  console.log(state.scopeOfWork);

  return sectorValidator(state?.scopeOfWork);
};
const validateScopeOfWorkBasic = (state: any): true | string => {
  const sow = state?.scopeOfWork;

  if (!Array.isArray(sow) || sow.length === 0) {
    return "You must create at least one service";
  }

  const hasValidItems = sow.some((item: any) => item.mode === "locked" && item.serviceUid && item.units && Number(item.units) > 0);

  if (!hasValidItems) {
    return "You must add and save at least one service";
  }

  return true;
};
